import BaseEndpoint from "./BaseEndpoint";
import Urls from "./Urls";
import Point from "ol/geom/Point";
import { toWebMercatorCenter } from "../../lib/map/core/transfomer";

/**
 * Geocode endpoint.
 */
export default class GeocodeEndpoint extends BaseEndpoint {
  /**
   * Returns a promise resolving geocode data.
   *
   * @returns {Promise<any>} geocode data.
   */
  address(address, myLocation) {
    if (address === undefined || (typeof address === "string" && address.length === 0)) {
      return Promise.resolve({});
    }

    let latLonPattern = /(^\s*-{1}\d+(\.\d+)?\s*,\s*\d+(\.\d+)?\s*$)|(^\s*\d+(\.\d+)?\s*,\s*-{1}\d+(\.\d+)?\s*$)/;
    let isValidLatLon = address.search(latLonPattern) === -1 ? false : true;
    let url;
    if (isValidLatLon && address.split(",").length === 2) {
      let coordinates = address.split(",");
      let x = parseFloat(coordinates[0]);
      let y = parseFloat(coordinates[1]);
      let coordinatesDecimal = x > y ? [y, x] : [x, y];
      let point = new Point(coordinatesDecimal);
      let extent = point.getExtent();
      return Promise.resolve({
        name: "Latitude / Longitude Coordinate",
        confidence: null,
        entityType: null,
        point: coordinatesDecimal.reverse(),
        extent: extent
      });
    } else {
      url = `${super.url(Urls.Geocode.Address)}?address=${address}`;
    }

    if (myLocation) {
      url += `&userLocation=${myLocation[0]}&userLocation=${myLocation[1]}`;
    }

    return super
      .get(url, {})
      .then(response =>
        response.json().catch(ex => {
          console.log(ex);
          return {};
        })
      )
      .then(json => json);
  }

  geocodeLocal(searchTerm) {
    if (searchTerm === undefined || (typeof searchTerm === "string" && searchTerm.length === 0)) {
      return Promise.resolve({});
    }

    let criteria = {
      locationName: `/%${searchTerm}/%`,
      top: 10,
      includeMetadataInResponse: false
    };

    let url = `${super.url(Urls.Geocode.GeocodeLocal)}?${super.toParameterString(criteria)}`;

    return super
      .get(url, {})
      .then(response => response.json())
      .then(json => {
        json.queryResults.forEach(item => {
          item.label = item.locationName;
        });
        return json.queryResults;
      });
  }
}
